import * as Arr from 'fp-ts/Array';
import * as O from 'fp-ts/Option';
import { constFalse, pipe } from 'fp-ts/lib/function';
import { iso } from 'newtype-ts';
import { match } from 'ts-pattern';
import { Fixtuur } from '..';
import * as Sel from './configuration/selections';
import * as Res from './inspirationProduct/resolution';
import * as Pr from './product';
const _ = iso();
export const create = _.wrap;
export const productById = (id) => (ip) => {
    return pipe(ip, _.unwrap, ip_ => ip_.variants, Arr.findFirst(p => Pr.id(p) === id));
};
export const productType = (ip, selectedVariantId) => pipe(ip, productById(selectedVariantId), O.map(Pr.productType), O.toUndefined);
export const variants = (ip) => _.unwrap(ip).variants;
export const isPropertyCurrentlySelected = (selectedVariantId, propertyName, propertyValue, inspoProduct) => pipe(propertySelections(inspoProduct, selectedVariantId), O.map(selections => Fixtuur.Configuration.Selections.getByName(selections, propertyName) ===
    propertyValue.displayText), O.getOrElse(constFalse));
export const propertySelections = (inspoProduct, selectedVariantId) => pipe(inspoProduct, productById(selectedVariantId), O.map(Sel.getPropertySelectionsForProduct));
export const isPropertyCompatible = (selectedVariantId, propertyName, propertyValue, inspoProduct) => {
    if (isPropertyCurrentlySelected(selectedVariantId, propertyName, propertyValue, inspoProduct))
        return true;
    // find properties from current product which aren't this property
    // then find all variants which match those properties
    // then check if any of those variants have this property set to this value
    // if they do, then this property is compatible
    const currentSelections = pipe(inspoProduct, productById(selectedVariantId), O.map(Fixtuur.Configuration.Selections.getPropertySelectionsForProduct), O.getOrElse(() => Fixtuur.Configuration.Selections.empty()));
    const otherSelections = Fixtuur.Configuration.Selections.removeKeys(currentSelections, [
        propertyName,
    ]);
    const variantsWithOtherProperties = pipe(inspoProduct, variants, Arr.filter(v => {
        const variantSelections = Fixtuur.Configuration.Selections.toApi(Fixtuur.Configuration.Selections.getPropertySelectionsForProduct(v));
        return Fixtuur.Configuration.Selections.entries(otherSelections).every(([name, value]) => (variantSelections[name] ?? null) === value);
    }));
    // TODO: we might need some better type for Fixtuur Product Properties - so we can do these kinds of comparisons without digging too deep
    // also, where do our propertyValues here come from? Can we construct those direct fromt the Fixtuur Product and compare them instead?
    // do any variants with the other properties shared by the selected variant also have the current property?
    return variantsWithOtherProperties.some(v => {
        const variantSelections = Fixtuur.Configuration.Selections.toApi(Fixtuur.Configuration.Selections.getPropertySelectionsForProduct(v));
        return variantSelections[propertyName] === propertyValue.displayText;
    });
};
export const resolve = (
/**
 * Multiple Selections allow us to work through each proposal one at a time, in importance order.
 * This ensures we can always resolve the users latest choice first, and then work through the rest
 * until we've found every valid property within the proposal.
 */
proposal, ip) => {
    return pipe(Res.resolve(ip, proposal), result => match(result)
        .with({ _tag: 'FinalResult' }, ({ selectedProductId }) => selectedProductId)
        .with({ _tag: 'IntermediateResult' }, () => O.none)
        .exhaustive());
};
